import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/almacen-vehicular/';

/**
 * GET AlmacenesVehiculares
 * @returns {Promise<Array<object>>}
 */
export const getAlmacenesVehiculares = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET AlmacenVehicular
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getAlmacenVehicular = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST AlmacenVehicular
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postAlmacenVehicular = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH AlmacenVehicular
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchAlmacenVehicular = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE AlmacenVehicular
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteAlmacenVehicular = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
